import styled, { keyframes } from 'styled-components';

const spin = keyframes`
    0% {
        transform: rotate(0deg);
    }
    100% {
        transform: rotate(360deg);
    }
`;

export const LoaderContainer = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    min-height: ${props => props.fullScreen ? '100vh' : '200px'};
    color: #B6C2CF;
`;

export const SpinnerWrapper = styled.div`
    position: relative;
    width: 40px;
    height: 40px;
    margin-bottom: 16px;
`;

export const Spinner = styled.div`
    position: absolute;
    width: 100%;
    height: 100%;
    border: 3px solid transparent;
    border-top-color: #579DFF;
    border-radius: 50%;
    animation: ${spin} 1s cubic-bezier(0.76, 0.35, 0.2, 0.7) infinite;
    
    &::before {
        content: '';
        position: absolute;
        top: -3px;
        left: -3px;
        right: -3px;
        bottom: -3px;
        border: 3px solid transparent;
        border-top-color: rgba(87, 157, 255, 0.5);
        border-radius: 50%;
        animation: ${spin} 2s cubic-bezier(0.76, 0.35, 0.2, 0.7) infinite;
    }

    &::after {
        content: '';
        position: absolute;
        top: 3px;
        left: 3px;
        right: 3px;
        bottom: 3px;
        border: 3px solid transparent;
        border-top-color: rgba(87, 157, 255, 0.3);
        border-radius: 50%;
        animation: ${spin} 1.5s cubic-bezier(0.76, 0.35, 0.2, 0.7) infinite reverse;
    }
`;

export const LoadingText = styled.div`
    font-size: 14px;
    color: #8C9BAB;
    margin-top: 8px;
`;

export const SmallSpinnerWrapper = styled(SpinnerWrapper)`
    width: 24px;
    height: 24px;
`;

export const SmallLoaderContainer = styled(LoaderContainer)`
    min-height: ${props => props.fullScreen ? '100vh' : '100px'};
`;

export const LoaderOverlay = styled(LoaderContainer)`
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(34, 39, 43, 0.8);
    z-index: 1000;
    min-height: 0;
`;
